import React, { Component } from 'react';
import i18next from "../../i18n.js";
export class DoubleCheckboxInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidUpdate() {
        if (this.props.value !== undefined && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value });
        }
    }
    render() {
        const { name, disabled } = this.props;
        const { value } = this.state;
        let firstSelected = !!value;
        let secondSelected = value !== undefined && !value;
        return (
            <div className="double-checkbox-form">
                <div>
                    <input id={name + "_first"} name={name + "_first"} checked={firstSelected} className="form-control" onChange={this.handleChange} type="checkbox" disabled={disabled ? "disabled" : ""} />
                    <label htmlFor={name + "_first"}>{i18next.t("yes")}</label>
                </div>
                <div>
                    <input id={name + "_second"} name={name + "_second"} checked={secondSelected} className="form-control" onChange={this.handleChange} type="checkbox" disabled={disabled ? "disabled" : ""} />
                    <label htmlFor={name + "_second"}>{i18next.t("no")}</label>
                </div>
            </div>
        );
    }
    handleChange(e) {
        const targetName = e.target.name;
        const targetValue = e.target.checked;
        if (targetValue) {
            let newValue = targetName.endsWith("_first");
            this.setState({ value: newValue });
            if (this.props.onChange) {
                const { name } = this.props;
                var ev = {};
                ev.target = {
                    name: name,
                    value: newValue
                };
                this.props.onChange(ev);
            }
        }
    }
}